import React, { useEffect, useState } from "react";
import TextWithTooltip from "./TextWithTooltip";
import AccessField from "../AccountDetails/Opportunities/accessEmailComp/AccessField";
import AccessPhoneButton from "../AccountDetails/Opportunities/accessEmailComp/AccessPhoneField";
import GenericTable from "../genericComponents/genericTableComp/GenericTable";
import { useUser } from "../../../context/UserContext";
import { enrichContactV2, getContactsFromCredits, loadContactsByFilter } from "../../../services/iqApiV2";
import { useBanner } from "../../../context/BannerContext";
import StatusIndicator from "../genericComponents/resizeableTable/StatusIndicator";
import { addStreamListener, initStreamSW, startPhoneStream } from "../../../streaming/streamSwClient";
import GenericTagComp from "../genericComponents/tag/GenericTagComp";
import TextTooltipOnly from "./TextTooltipOnly";
import { Info } from "react-feather";
import GenericFloatingBanner from "../genericComponents/uiElements/GenericFloatingBanner";

function SavedContactContent({ content }) {
  const [tabData, setTabData] = useState([]);
  const { user } = useUser();
  const [loading, setLoading] = useState(false);

  const [contactData, setContactData] = useState([]);
  const [banner, setBanner] = useState(null);

  const triggerBanner = ({ message, type = "info", duration = 4000 }) => {
    setBanner({
      id: Date.now(),
      message,
      type,
      duration,
    });
  };

  const copyToClipboard = (text,type = "email") => {
    if (!text) return;
    navigator.clipboard.writeText(text)
      .then(() => {
        triggerBanner({
                  message: type === "phone"
                    ? "Phone Number Copied Successfully"
                    : "Email Copied Successfully",
                  type: "success",
                  duration: 3000,
                });
      })
      .catch((err) => {
        triggerBanner({
          message: "Failed to copy",
          type: "error",
          duration: 3000,
        });
    });
  };

  const handleOnAccessEmailClick = async (e, userId, apolloId, accessPhone = false) => {
  e.preventDefault();
  e.stopPropagation();

  if (!userId || !apolloId) {
    console.warn("Missing userId or apolloId for enrichContact");
    return;
  }

  try {
    const resp = await enrichContactV2(userId, apolloId, accessPhone, () => {}, () => {});

    const updatedEmail = resp?.email;
    const updatedPhone = resp?.phone;
    if (!updatedEmail && !accessPhone) {

         triggerBanner({
          message: "Not Found.",
          type: "error",
          duration: 3000,
        });
      return; // stop further state updates
    }


    // Mark phone as pending in localStorage if fetching phone
    if (accessPhone) {
      const key = `${user.id}_${apolloId}_phone_pending`;
      localStorage.setItem(key, JSON.stringify({ ts: Date.now() }));

    await startPhoneStream(apolloId);
    }

    // Update tabData state
    setContactData((prev) => {
      if (!Array.isArray(prev)) return prev;

      return prev.map((item) => {
        if (item.id !== apolloId) return item;

        return {
          ...item,
          ...(accessPhone
            ? { phone: updatedPhone } // update phone
            : { email: updatedEmail } // update email
          ),
        };
      });
    });
    
  } catch (err) {
    console.error("Failed to enrich contact:", err);
  }
};


  const safeOpenUrl = (url) => {
    if (!url || typeof url !== "string") return;

    const finalUrl = url.startsWith("http") ? url : `https://${url}`;

    try {
      window.open(finalUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Failed to open URL:", err);
    }
  };

  const tableColumns = [
    { id: "contactName", label: "Name", width: 100, alignment: "flex-start" },
    { id: "domains", label: "Organization", width: 100, alignment: "flex-start" },
    { id: "location", label: "Location", width: 110, alignment: "flex-start" },
    { id: "linkedinUrl", label: "LinkedIn", width: 50, alignment: "flex-start" },
    {
      id: "emailAccess",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          Email
          <TextTooltipOnly
            text="Emails consume 2 credits. Results are instant." // Tooltip content for email access
            // className="info-icon"
            placement="top"
          >
            <Info size={12} style={{ opacity: 0.6, cursor: "pointer" }} />
          </TextTooltipOnly>
        </div>
      ),
      width: 150,
      alignment: "center",
    },
    {
      id: "phoneAccess",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          Phone
          <TextTooltipOnly
            text="Phone numbers consume 10 credits. Results in 3–5 minutes." // Tooltip content for phone access
            
            placement="top"
          >
            <Info size={12} style={{ opacity: 0.6, cursor: "pointer" }} />
          </TextTooltipOnly>
        </div>
      ),
      width: 100,
      alignment: "center",
    },
  ];
useEffect(() => {
  if (!content?.id) return;

  async function fetchData() {
    try {
      setLoading(true);
      let resp = [];
      if (content?.defaultList) {
         resp = await getContactsFromCredits(user?.id);
      }else{
          resp = await loadContactsByFilter(content?.id);
      }
    

      const unique = resp.filter(
        (item, index, arr) => index === arr.findIndex(x => x.id === item.id)
      );

      setContactData(unique); 
    } catch (e) {
      console.error("Error fetching contact data", e);
      setContactData([]);
    } finally {
      setLoading(false);
    }
  }

  fetchData();
}, [content?.id]);

  useEffect(() => {
    

      async function fetchData(){
        try{
        


      const enhanced = contactData.map((item) => {
        if (!item) return {};
        
        const organization = item?.organization ?? {};
        const orgName = organization?.name || "Unknown Organization";

        const locationString = [item?.city, item?.state, item?.country]
          .filter(Boolean)
          .join(", ");
        const key = `${user?.id}_${item?.id}_phone_pending`;
        const pendingEntry = localStorage.getItem(key);

        let isPhonePending = false;

        if (pendingEntry) {
          const { ts } = JSON.parse(pendingEntry);
          const oneHour = 60 * 60 * 1000;

          // expires after 1 hour just like GlobalContactSearchResult
          const expired = Date.now() - ts > oneHour;

          if (expired) {
            localStorage.removeItem(key);
          } else {
            isPhonePending = true;
          }
        }
        

        return {
          ...item,
          id: item?.id ?? item?._id ?? Math.random().toString(),

          contactName: (
            <div style={{display:"flex",justifyContent:"center",flexDirection:"column" , width:"100%"}}>
            <TextWithTooltip
              className="single-line-ellipse_gcsrt"
              text={item?.name}
            />
              <TextWithTooltip text={item?.title} className="enhancerows_gcsrt" />
            </div>
          ),

          location: (
            <TextWithTooltip
              text={locationString || "-"}
              className="enhancerows_gcsrt"
            />
          ),

          domains: (
            <>
              {organization?.name ? (
                <a
                  href={organization.website_url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    textDecoration: "none",
                    color: "inherit",
                    gap: "8px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    safeOpenUrl(organization.website_url);
                  }}
                >
                  {organization.logo_url && (
                    <img
                      src={organization.logo_url}
                      alt={`${orgName} logo`}
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                        borderRadius: "4px",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  )}

                  <TextWithTooltip
                    text={orgName}
                    className="enhancerows_gcsrt_org"
                  />
                </a>
              ) : (
                item?.account?.domain || item?.account?.primary_domain || "-"
              )}
            </>
          ),

          linkedinUrl: item?.linkedin_url ? (
            <a
              href={item.linkedin_url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="scrc-linkedin"
              title="View on LinkedIn"
              onClick={(e) => {
                e.preventDefault();
                safeOpenUrl(item.linkedin_url);
              }}
            >
              <i className="fa fa-linkedin-square" aria-hidden="true"></i>
            </a>
          ) : (
            "-"
          ),

          emailAccess: (
            <AccessField
              field_value={item?.email}
              onAccessClick={(e) =>
                handleOnAccessEmailClick(e, user?.id, item?.id, false)
              }
              showCopyButton={true}
              copyToClipboard={copyToClipboard}
            />
          ),

          phoneAccess: isPhonePending ? (
            <StatusIndicator text="Fetching Number" />
          ) : item?.phone === "Not Found" ? (
       
                <GenericTagComp
                  color={"red"}
                  onChipClick={() => {}}
                  text={"Not Found"}
                />
  
          ) : (
            <AccessPhoneButton
              phone={item?.phone}
              onAccessClick={(e) =>
                handleOnAccessEmailClick(e, user?.id, item?.id, true)
              }
              showCopyButton={true}
              copyToClipboard={(value) => copyToClipboard(value, "phone")}
            />
          ),
        };
        });

      setTabData(enhanced);
      
      }


     catch (err) {
  console.error("Error while preparing contact rows:", err);
      setTabData([]);
    }
    finally{
      setLoading(false);
    }
  }

    if (content?.id) {
      fetchData()
    }


   
  }, [contactData]);




useEffect(() => {
  let removeListener = null;

  const setup = async () => {
    try {
      await initStreamSW(); // ensure SW is ready

      removeListener = addStreamListener((msg) => {
        if (msg.type === "PHONE_UPDATE") {
           const key = `${user?.id}_${msg.apolloId}_phone_pending`;
           localStorage.removeItem(key)
          setContactData((prev) =>
            prev.map((c) =>
              c.id === msg.apolloId ? { ...c, phone: msg.phone } : c
            )
          );
        }  if (msg.type === "PHONE_UPDATE_ERROR") {
          const key = `${user?.id}_${msg.apolloId}_phone_pending`;
           localStorage.removeItem(key)
           setContactData((prev) =>
            prev.map((c) =>
              c.id === msg.apolloId ? { ...c, phone: "Not Found"} : c
            )
          );
          console.log("No phone found:", msg.message);
        }
      });
    } catch (err) {
      console.error("Stream SW init failed:", err);
    }
  };

  setup();

  return () => {
    if (typeof removeListener === "function") {
      removeListener(); // safely remove listener
    }
  };
}, []);

  

  return (
    <div className="sgc-content-placeholder">
       {banner && (
        <GenericFloatingBanner
          key={banner.id}
          message={banner.message}
          type={banner.type}
          duration={banner.duration}
          onClose={() => setBanner(null)}
        />
      )}
      <GenericTable
        disableSort={true}
        allowSelection={false}
        enablePagination={false}
        initialColumns={tableColumns}
        tabData={Array.isArray(tabData) ? tabData : []}
        onRowsPerPageChange={null}
        oppName={null}
        loadingRows={15}
        loading={loading}
      />
    </div>
  );
}

export default SavedContactContent;
